var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.widgetSize')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.size),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "size", $$v)
      },
      expression: "optionModel.size"
    }
  }, _vm._l((_vm.widgetSizes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208978a5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-button-group/button-group-size-editor.vue
// module id = null
// module chunks = 